export const dispatchNative = (el, type) => {
  el.dispatchEvent(new Event(type, { bubbles: true }));
};

// React installs its own instance-level setter over the native value/
// checked properties to power its own change tracking, so a plain
// `el.value = x` leaves React believing nothing changed and a dispatched
// input/change event is silently ignored - never running onChange, never
// setting customValidity, so a restored invalid value never gets flagged.
// Going through the underlying native setter (bypassing React's) then
// dispatching the event is the standard fix.
export const setNativeProperty = (el, prop, value) => {
  const prototype = Object.getPrototypeOf(el);
  const nativeSetter = Object.getOwnPropertyDescriptor(prototype, prop)?.set;
  if (nativeSetter) {
    nativeSetter.call(el, value);
  } else {
    el[prop] = value;
  }
};
